document.addEventListener('DOMContentLoaded', function () {
  var dataEl = document.querySelector('[data-marking-preview-data]');
  if (!dataEl) return;

  var allPreviews = JSON.parse(dataEl.textContent);
  if (!Array.isArray(allPreviews) || allPreviews.length === 0) return;

  var previewData = null;

  // Preview canvas elements
  var canvas = document.querySelector('[data-product-marking-preview]');
  if (!canvas) return;

  var overlayNumber = canvas.querySelector('[data-preview-overlay-number]');
  var overlayName = canvas.querySelector('[data-preview-overlay-name]');
  var optionOverlaysContainer = canvas.querySelector('[data-preview-overlay-options]');
  var baseImages = document.querySelectorAll('[data-preview-base-image]');
  var thumbImage = document.querySelector('[data-media-id="marking-preview"] .media--thumb img');

  // Settings from marking_preview metaobject
  var settings = {};

  // Marking option overlays
  var markingOptions = [];

  // Current preview state
  var currentName = '';
  var currentNumber = '';

  // --- INIT PREVIEW ---

  function initPreview(index) {
    previewData = allPreviews[index];

    // Reset settings to defaults
    settings = {
      number_top: 32,
      number_height: 15,
      number_gap: 0.5,
      name_top: 20,
      name_height: 5,
      name_gap: 0.3,
      name_round: 0,
    };

    // Merge saved settings
    if (previewData.settings) {
      var s = previewData.settings;
      if (s.number_top != null) settings.number_top = s.number_top;
      if (s.number_height != null) settings.number_height = s.number_height;
      if (s.number_gap != null) settings.number_gap = s.number_gap;
      if (s.name_top != null) settings.name_top = s.name_top;
      if (s.name_height != null) settings.name_height = s.name_height;
      if (s.name_gap != null) settings.name_gap = s.name_gap;
      if (s.name_round != null) settings.name_round = s.name_round;
    }

    // Merge special character images into images map (uppercase key for consistent lookup)
    if (previewData.specials) {
      previewData.specials.forEach(function (sp) {
        if (sp.text && sp.img) {
          previewData.images[sp.text.normalize('NFC').toUpperCase()] = sp.img;
        }
      });
    }

    // Update base images (gallery slide + grid)
    if (previewData.img_base) {
      baseImages.forEach(function (img) {
        img.src = previewData.img_base;
      });
      // Update thumbnail
      if (thumbImage) {
        thumbImage.src = previewData.img_base;
      }
    }

    // Remove old option overlays from DOM
    markingOptions.forEach(function (opt) {
      if (opt._overlay && opt._overlay.parentNode) {
        opt._overlay.parentNode.removeChild(opt._overlay);
      }
    });
    markingOptions = [];

    // Rebuild marking option overlays
    if (previewData.marking_option_products && previewData.marking_option_products.length > 0) {
      var savedOptions = (previewData.settings && Array.isArray(previewData.settings.marking_options))
        ? previewData.settings.marking_options
        : [];

      previewData.marking_option_products.forEach(function (product) {
        var saved = savedOptions.find(function (o) { return o.product_id === product.id; });
        var opt = {
          product_id: product.id,
          title: product.title,
          img: product.img,
          top: saved && saved.top != null ? saved.top : 25,
          left: saved && saved.left != null ? saved.left : 17,
          height: saved && saved.height != null ? saved.height : 10,
          rotate: saved && saved.rotate != null ? saved.rotate : 30,
          layout: saved && saved.layout != null ? saved.layout : 'half_right',
          _overlay: null,
          _visible: false,
        };

        var overlay = document.createElement('div');
        overlay.className = 'product-marking-preview__overlay product-marking-preview__overlay--option';
        overlay.style.display = 'none';
        (optionOverlaysContainer || canvas).appendChild(overlay);
        opt._overlay = overlay;

        markingOptions.push(opt);
      });
    }

    // このプレビューで選択可能なマーキングオプション商品を公開し、オプション側に絞り込みを促す
    window.markingPreviewState = {
      allowedOptionProductIds: (previewData.marking_option_products || []).map(function (product) {
        return product.id;
      }),
    };
    document.dispatchEvent(new Event('marking:preview-change'));

    // Re-apply marking option visibility
    updateMarkingOptionOverlays();

    // Re-render preview
    updatePreview();
  }

  // --- NAME PATTERN (special character support) ---

  function getNamePattern() {
    var specialChars = '';
    if (previewData.specials) {
      previewData.specials.forEach(function (sp) {
        if (sp.text) specialChars += sp.text.normalize('NFC').toUpperCase();
      });
    }
    var escaped = specialChars.replace(/[-.*+?^${}()|[\]\\]/g, '\\$&');
    return new RegExp('[^A-Z .' + escaped + ']', 'g');
  }

  // --- RENDERING FUNCTIONS ---

  function updatePreview() {
    renderOverlay(overlayNumber, currentNumber, 'number');
    renderOverlay(overlayName, currentName, 'name');

    for (var i = 0; i < markingOptions.length; i++) {
      updateOptionOverlay(i);
    }
  }

  function renderOverlay(container, text, type) {
    if (!container) return;

    var top = settings[type + '_top'];
    var height = settings[type + '_height'];
    var gap = settings[type + '_gap'];
    var round = (type === 'name') ? (settings.name_round || 0) : 0;

    container.innerHTML = '';

    if (!text) return;

    container.style.top = top + '%';
    container.style.height = height + '%';
    container.style.gap = gap + '%';
    container.style.display = 'flex';
    container.style.justifyContent = 'center';
    container.style.alignItems = 'flex-start';
    container.style.left = '0';
    container.style.width = '100%';
    container.style.overflow = (round !== 0) ? 'visible' : '';

    renderFlexCharacters(container, text, gap);

    if (round !== 0 && type === 'name') {
      applyArcTransform(container, round);
    }
  }

  function renderFlexCharacters(container, text, gap) {
    var chars = text.normalize('NFC').split('');
    for (var i = 0; i < chars.length; i++) {
      var char = chars[i];

      if (char === ' ') {
        var spacer = document.createElement('div');
        spacer.innerHTML = '&nbsp;';
        spacer.style.flex = '0 0 ' + (gap * 3) + '%';
        spacer.style.height = '100%';
        spacer.style.overflow = 'hidden';
        container.appendChild(spacer);
        continue;
      }

      var charKey = char.toUpperCase();
      var imgUrl = previewData.images[charKey];

      if (imgUrl) {
        var img = document.createElement('img');
        img.src = imgUrl;
        img.alt = char;
        img.draggable = false;
        container.appendChild(img);
      }
    }
  }

  function applyArcTransform(container, arcDegree) {
    var direction = arcDegree > 0 ? 1 : -1;
    var absArcRad = Math.abs(arcDegree) * Math.PI / 180;
    if (absArcRad < 0.001) return;

    var retryCount = 0;

    function doTransform() {
      var currentImgs = container.querySelectorAll('img');
      if (currentImgs.length === 0) return;

      container.offsetHeight;

      var canvasRect = canvas.getBoundingClientRect();
      var centerX = canvasRect.width / 2;

      var charData = [];
      for (var i = 0; i < currentImgs.length; i++) {
        var rect = currentImgs[i].getBoundingClientRect();
        charData.push({
          img: currentImgs[i],
          left: rect.left - canvasRect.left,
          width: rect.width,
          centerX: rect.left + rect.width / 2 - canvasRect.left
        });
      }

      var textLeft = charData[0].left;
      var textRight = charData[charData.length - 1].left + charData[charData.length - 1].width;
      var textWidth = textRight - textLeft;

      if (textWidth <= 0) {
        retryCount++;
        if (retryCount < 10) setTimeout(doTransform, 50);
        return;
      }

      var charCount = charData.length;
      var refTextWidth = (charCount < 12) ? textWidth * (12 / charCount) : textWidth;
      var R = refTextWidth / absArcRad;
      var textCenterX = textLeft + textWidth / 2;

      for (var i = 0; i < charData.length; i++) {
        var c = charData[i];
        var linearOffset = c.centerX - textCenterX;
        var angle = linearOffset / R;
        var arcX = centerX + R * Math.sin(angle);
        var arcY = direction * R * (1 - Math.cos(angle));
        var dx = arcX - c.centerX;
        var rotDeg = direction * angle * (180 / Math.PI);
        c.img.style.transform = 'translateX(' + dx + 'px) translateY(' + arcY + 'px) rotate(' + rotDeg + 'deg)';
      }
    }

    function scheduleTransform() {
      requestAnimationFrame(function () {
        requestAnimationFrame(doTransform);
      });
    }

    var imgs = container.querySelectorAll('img');
    if (imgs.length === 0) return;

    var allLoaded = Array.prototype.every.call(imgs, function (img) { return img.complete; });
    if (allLoaded) {
      scheduleTransform();
    } else {
      var loadCount = 0;
      var total = imgs.length;
      imgs.forEach(function (img) {
        if (img.complete) {
          loadCount++;
        } else {
          img.addEventListener('load', function () {
            loadCount++;
            if (loadCount === total) scheduleTransform();
          }, { once: true });
        }
      });
      if (loadCount === total) scheduleTransform();
    }
  }

  function updateOptionOverlay(idx) {
    var opt = markingOptions[idx];
    if (!opt || !opt._overlay) return;

    var overlay = opt._overlay;
    overlay.innerHTML = '';

    if (!opt._visible || !opt.img) {
      overlay.style.display = 'none';
      return;
    }

    overlay.style.display = '';
    overlay.style.top = opt.top + '%';
    overlay.style.left = opt.left + '%';
    overlay.style.height = opt.height + '%';
    overlay.style.transform = 'translate(-50%, -50%) rotate(' + opt.rotate + 'deg)';

    var wrapper = document.createElement('div');
    wrapper.className = 'product-marking-preview__option-crop';

    var img = document.createElement('img');
    img.src = opt.img;
    img.alt = opt.title || '';
    img.draggable = false;
    img.className = 'product-marking-preview__option-crop-img';
    img.style.maxWidth = 'none';
    img.style.maxHeight = 'none';
    img.style.objectFit = 'fill';

    function applyCrop() {
      var fullWidth = img.naturalWidth;
      var fullHeight = img.naturalHeight;
      var displayHeight = overlay.offsetHeight;
      var displayWidth = displayHeight * (fullWidth / fullHeight);
      var layout = opt.layout || 'all';

      if (layout === 'all') {
        wrapper.style.width = displayWidth + 'px';
        wrapper.style.height = displayHeight + 'px';
        img.style.width = displayWidth + 'px';
        img.style.height = displayHeight + 'px';
        img.style.marginLeft = '0';
        img.style.marginTop = '0';
      } else if (layout === 'half_left') {
        wrapper.style.width = (displayWidth / 2) + 'px';
        wrapper.style.height = displayHeight + 'px';
        img.style.width = displayWidth + 'px';
        img.style.height = displayHeight + 'px';
        img.style.marginLeft = '0';
        img.style.marginTop = '0';
      } else if (layout === 'half_right') {
        wrapper.style.width = (displayWidth / 2) + 'px';
        wrapper.style.height = displayHeight + 'px';
        img.style.width = displayWidth + 'px';
        img.style.height = displayHeight + 'px';
        img.style.marginLeft = -(displayWidth / 2) + 'px';
        img.style.marginTop = '0';
      } else if (layout === 'half_top') {
        wrapper.style.width = displayWidth + 'px';
        wrapper.style.height = (displayHeight / 2) + 'px';
        img.style.width = displayWidth + 'px';
        img.style.height = displayHeight + 'px';
        img.style.marginLeft = '0';
        img.style.marginTop = '0';
      } else if (layout === 'half_bottom') {
        wrapper.style.width = displayWidth + 'px';
        wrapper.style.height = (displayHeight / 2) + 'px';
        img.style.width = displayWidth + 'px';
        img.style.height = displayHeight + 'px';
        img.style.marginLeft = '0';
        img.style.marginTop = -(displayHeight / 2) + 'px';
      }
    }

    if (img.complete && img.naturalWidth > 0) {
      requestAnimationFrame(function () { requestAnimationFrame(applyCrop); });
    } else {
      img.addEventListener('load', function () {
        requestAnimationFrame(applyCrop);
      }, { once: true });
    }

    wrapper.appendChild(img);
    overlay.appendChild(wrapper);
  }

  // --- MARKING OPTION LISTENERS ---

  var markingOptionDataEl = document.querySelector('[data-marking-option-data]');
  var markingOptionData = markingOptionDataEl ? JSON.parse(markingOptionDataEl.textContent) : null;
  var markingOptionTypeSelect = document.getElementById('marking-option-type-select');
  var markingOptionSetSelect = document.getElementById('marking-option-set-select');

  function updateMarkingOptionOverlays() {
    if (!markingOptionData) return;

    // Reset all
    markingOptions.forEach(function (opt) { opt._visible = false; });

    var optionType = markingOptionTypeSelect ? markingOptionTypeSelect.value : '';

    if (optionType === 'set') {
      var selectedSetName = markingOptionSetSelect ? markingOptionSetSelect.value : '';
      if (selectedSetName) {
        var selectedSet = markingOptionData.option_sets.find(function (set) { return set.name === selectedSetName; });
        if (selectedSet && selectedSet.products) {
          selectedSet.products.forEach(function (product) {
            var opt = markingOptions.find(function (o) { return o.product_id === product.id; });
            if (opt) opt._visible = true;
          });
        }
      }
    } else if (optionType === 'single') {
      var checkedBoxes = document.querySelectorAll('.marking-option-single-item-checkbox:checked');
      checkedBoxes.forEach(function (checkbox) {
        var optionName = checkbox.value;
        var selectedOption = markingOptionData.single_options.find(function (option) { return option.name === optionName; });
        if (selectedOption && selectedOption.products) {
          selectedOption.products.forEach(function (product) {
            var opt = markingOptions.find(function (o) { return o.product_id === product.id; });
            if (opt) opt._visible = true;
          });
        }
      });
    }

    for (var i = 0; i < markingOptions.length; i++) {
      updateOptionOverlay(i);
    }
  }

  // --- INIT FIRST PREVIEW ---

  var firstSelectableIndex = 0;
  for (var i = 0; i < allPreviews.length; i++) {
    if (allPreviews[i].is_selectable) {
      firstSelectableIndex = i;
      break;
    }
  }
  initPreview(firstSelectableIndex);

  // --- EVENT LISTENERS ---

  var markingDataEl = document.querySelector('[data-marking-data]');
  var markingData = markingDataEl ? JSON.parse(markingDataEl.textContent) : null;

  var markingTypeSelect = document.getElementById('marking-type-select');
  var markingPlayerSelect = document.getElementById('marking-player-select');
  var markingCustomNameInput = document.getElementById('marking-custom-name');
  var markingCustomNumberInput = document.getElementById('marking-custom-number');

  // 特殊文字対応: name inputのHTML pattern属性を除去し、JSでフィルタリング
  if (markingCustomNameInput) {
    markingCustomNameInput.removeAttribute('pattern');
  }

  // Design selection (multiple previews)
  var markingDesignSelect = document.getElementById('marking-design-select');
  if (markingDesignSelect) {
    markingDesignSelect.addEventListener('change', function () {
      var idx = parseInt(this.value, 10);
      if (!isNaN(idx) && idx >= 0 && idx < allPreviews.length) {
        initPreview(idx);
      }
    });
  }

  // Marking type change
  if (markingTypeSelect) {
    markingTypeSelect.addEventListener('change', function () {
      var type = this.value;
      if (type === 'none') {
        currentName = '';
        currentNumber = '';
      } else if (type === 'player') {
        currentName = '';
        currentNumber = '';
      } else if (type === 'custom') {
        currentName = markingCustomNameInput ? markingCustomNameInput.value.normalize('NFC').toUpperCase().replace(getNamePattern(), '') : '';
        currentNumber = markingCustomNumberInput ? markingCustomNumberInput.value : '';

        // 現在のデザインがis_selectable: falseなら、最初のselectableに切替
        if (previewData && !previewData.is_selectable) {
          for (var i = 0; i < allPreviews.length; i++) {
            if (allPreviews[i].is_selectable) {
              initPreview(i);
              if (markingDesignSelect) {
                markingDesignSelect.value = String(i);
              }
              break;
            }
          }
        }
      }
      updatePreview();
    });
  }

  // Player selection
  if (markingPlayerSelect) {
    markingPlayerSelect.addEventListener('change', function () {
      var value = this.value;
      if (value && markingData && markingData.players) {
        // Find the selected player by matching the select value (#NUMBER NAME)
        var selectedPlayer = markingData.players.find(function (p) {
          return '#' + p.number + ' ' + p.name === value;
        });
        if (selectedPlayer) {
          currentNumber = selectedPlayer.number || '';
          currentName = selectedPlayer.name_text || '';

          // 選手指定デザインへの自動切替
          if (selectedPlayer.marking_preview_handles && selectedPlayer.marking_preview_handles.length > 0) {
            for (var i = 0; i < allPreviews.length; i++) {
              if (selectedPlayer.marking_preview_handles.indexOf(allPreviews[i].handle) !== -1) {
                initPreview(i);
                // ドロップダウンの同期（selectableなデザインの場合のみ）
                if (markingDesignSelect && allPreviews[i].is_selectable) {
                  markingDesignSelect.value = String(i);
                }
                break;
              }
            }
          }
        }
      } else {
        currentNumber = '';
        currentName = '';
      }
      updatePreview();
    });
  }

  // Custom name input
  if (markingCustomNameInput) {
    var nameMaxLength = parseInt(markingCustomNameInput.getAttribute('maxlength'), 10) || 12;

    markingCustomNameInput.addEventListener('input', function () {
      currentName = this.value.normalize('NFC').toUpperCase().replace(getNamePattern(), '').substring(0, nameMaxLength);
      updatePreview();
    });

    markingCustomNameInput.addEventListener('blur', function () {
      var filtered = this.value.normalize('NFC').toUpperCase().replace(getNamePattern(), '').substring(0, nameMaxLength);
      if (this.value !== filtered) {
        this.value = filtered;
      }
      currentName = filtered;
      updatePreview();
    });
  }

  // Custom number input (digits only)
  if (markingCustomNumberInput) {
    markingCustomNumberInput.addEventListener('input', function () {
      var filtered = this.value.replace(/[^0-9]/g, '');
      if (this.value !== filtered) {
        this.value = filtered;
      }
      currentNumber = filtered;
      updatePreview();
    });
  }

  // Marking option event listeners
  if (markingOptionTypeSelect) {
    markingOptionTypeSelect.addEventListener('change', updateMarkingOptionOverlays);
  }

  if (markingOptionSetSelect) {
    markingOptionSetSelect.addEventListener('change', updateMarkingOptionOverlays);
  }

  document.addEventListener('change', function (e) {
    if (e.target.classList.contains('marking-option-single-item-checkbox')) {
      updateMarkingOptionOverlays();
    }
  });

  // 絞り込みでオプションの選択状態が変わったときもプレビューを合わせる
  document.addEventListener('marking:options-changed', updateMarkingOptionOverlays);
});
